import React from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

const Services = () => {
  return (
    <div className='px-4 '>


      {/* <div className='border-blue-300 border-t-[1px] text-black max-w-[1200px] p-4 mx-auto'> </div>*/}


      <div className='text-black pt-12 md:pb-32 p-4 max-w-[1200px] mx-auto'>
        <motion.section
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0, transition: { duration: 1.5 } }}
          viewport={{ once: true }}
        >
          <div className='max-w-[800px]'>
            <h3 className='text-3xl font-bold pb-4  max-w-[600px]'>Upgrading or Creating</h3>
            <p className='text-2xl pb-8 text-gray-800'>Get help at any stage of the process.</p>
          </div>
          <div className='flex flex-col md:flex-row'>
            <div className='flex flex-col max-w-[800px]'>
              <div className='flex flex-col md:flex-row pb-8'>
                <p>Elevate Your Online Presence with Expert Website Services! Perfect solution for companies that already have an existing website running or for companies that are trying to establish their first online presence. Experience a tailored solution right for your business. Following modern design principles your user experience will be top notch. All plans come with SEO optimization, mobile responsive and fast turn around.</p>
              </div>
              <div className='flex-1'>
                <h3 className='text-3xl pb-4 font-bold'>Custom Design</h3>
                <p className=' pb-8 '>Fully customized layouts and pages. Choose the amount of custom pages you need and that will fit your required budget. All our plans include a fully custom design for the landing page, and from there you can extend it to the secondary pages of your website as needed. </p>
                <div className='ml-4 pl-2 border-[#3fc07c] border-l-[4px] mb-8'>

                  <p className='text-sm text-gray-600'>Custom landing page</p>
                  <p className='text-sm text-gray-600'>Optional custom secondary pages</p>
                  <p className='text-sm text-gray-600'>Responsive design</p>
                  <p className='text-sm text-gray-600'>Cross browser compatible</p>
                </div>
              </div>
              <div className='flex-1'>
                <h3 className='text-3xl pb-4 font-bold'>Full Service</h3>
                <p className='text-lg pb-8 text-gray-800'>Creating your website is just the beginning. We offer a full suite of optional services such as domain registration, hosting, copy writing, lead generation and more. You can choose to add on these services as your business grows.</p>
                <div className='ml-4 pl-2 border-[#3fc07c] border-l-[4px]'>
                  <p className='text-sm text-gray-600'>Domain registration</p>
                  <p className='text-sm text-gray-600'>Hosting</p>
                  <p className='text-sm text-gray-600'>Copy writing</p>
                  <p className='text-sm text-gray-600'>Lead generation</p>
                </div>
              </div>
              <div className='mx-auto mt-4'>
                <Link to='/services' className='inline-flex bg-[#3fc07c] hover:bg-[#34c6eb] text-white py-2 px-4 mr-4'>
                            View Services
                          </Link>
              </div>
            </div>

          </div>
        </motion.section>
      </div>


      {/* <div className='text-gray-700 pt-20 md:pb-80 p-4 max-w-[1200px] mx-auto'>
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0, transition: { duration: 1.5 } }}
          viewport={{ once: true }}
          className='flex flex-col md:flex-row'>
          <div className='flex-1 mb-16 md:mb-0'>
            <img src='images/web-design.svg' loading='lazy' className='' alt='custom design responsive on desktop and mobile' />
          </div>
          <div className='flex-1 md:pl-12'>
            <h3 className='text-3xl pb-4 font-bold'>Custom Design</h3>
            <p className='text-lg pb-8 text-gray-800'>Fully customized layouts and pages. Choose the amount of custom pages you need and that will fit your required budget. All our plans include a fully custom design for the landing page, and from there you can extend it to the secondary pages of your website as needed. </p>
            <p className=''>Custom landing page</p>
            <p>Optional custom secondary pages</p>
            <p>Responsive design</p>
            <p>Cross browser compatible</p>
          </div>
        </motion.div>
      </div>
      <div className='text-gray-700 pt-20 pb-80 p-4 max-w-[1200px] mx-auto'>
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0, transition: { duration: 1.5 } }}
          viewport={{ once: true }}
          className='flex flex-col md:flex-row'>
          <div className='flex-1 md:mr-12'>
            <h3 className='text-3xl pb-4 font-bold'>Full Service</h3>
            <p className='text-lg pb-8 text-gray-800'>Creating your website is just the beginning. We offer a full suite of optional services such as domain registration, hosting, copy writing, lead generation and more. You can choose to add on these services as your business grows.</p>
            <p>Domain registration</p>
            <p>Hosting</p>
            <p>Copy writing</p>
            <p>Lead generation</p>
          </div>
          <div className='flex-1 mt-16 md:mt-0'>
            <img src='images/web-design-1.svg' loading='lazy' alt='full service with many options for your website' />
          </div>
        </motion.div>
      </div> */}
    </div>
  )
}

export default Services